import { CloseButton } from "../components/CloseButton";
import { useModal } from "../components/Modal";
import { ModalSheet } from "../components/ModalSheet";
import type { useDiagnosticsModal } from "../diagnostics/Diagnostics";
import { EmailIcon, WhatsAppIcon } from "../icons";
import { Button } from "../ui/button";
import { ContactUsQRCode } from "./ContactUsQRCode";

export const ContactUs = () => (
  <div>
    <p className="pt-2 mb-4">Our Customer Support team are always happy to help.</p>
    <div className="flex gap-6 mb-4 items-center">
      <div className="flex-1 flex flex-col gap-2 justify-center">
        <div className="flex items-center gap-2 text-foreground">
          <EmailIcon />
          <span>Email:</span>{" "}
          <a
            href="mailto:support@artis.works"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >
            support@artis.works
          </a>
        </div>
        <div className="flex items-center gap-2 text-foreground">
          <WhatsAppIcon />
          <span>WhatsApp:</span>{" "}
          <a
            href="https://wa.me/447537143416"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >
            +44 7537 143416
          </a>
        </div>
      </div>
      <div className="flex-shrink-0">
        <ContactUsQRCode />
      </div>
    </div>
  </div>
);

export function useContactSupportModal({
  diagnosticsModal,
}: {
  diagnosticsModal: ReturnType<typeof useDiagnosticsModal>;
}) {
  const contactSupportModal = useModal(() => (
    <ModalSheet
      title="Contact Us"
      onClose={() => contactSupportModal.close()}
      footer={
        <div className="flex justify-between items-center">
          <Button buttonType="linkButton" onClick={() => diagnosticsModal.open()} className="text-md px-[9px] h-[27px]">
            Send Diagnostics
          </Button>
          <CloseButton variant={"secondary"} onClick={contactSupportModal.close} />
        </div>
      }
    >
      <div className="overflow-y-auto max-h-[80vh] text-foreground-muted">
        <ContactUs />
      </div>
    </ModalSheet>
  ));

  return contactSupportModal;
}
